<div class="place-holding"></div>

<div class="privacy-page">
  <section class="privacy-hero">
    <div class="privacy-hero__badge">Policy</div>
    <h1 class="privacy-title">
      {{ 'Privacy.title' | translate }}
    </h1>
    <p class="privacy-hero__desc">
      我们以清晰、必要、最小化的方式说明信息收集、使用与保护规则，帮助你快速理解本站的隐私处理方式。
    </p>
  </section>

  <div class="privacy-layout">
    <aside class="privacy-aside">
      <div class="privacy-toc">
        <p class="privacy-toc__title">目录</p>
        <button type="button" (click)="scrollToSection('privacy-section-1')">{{ 'Privacy.section1.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('privacy-section-2')">{{ 'Privacy.section2.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('privacy-section-3')">{{ 'Privacy.section3.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('privacy-section-4')">{{ 'Privacy.section4.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('privacy-section-5')">{{ 'Privacy.section5.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('privacy-section-6')">{{ 'Privacy.section6.title' | translate }}</button>
        <button type="button" (click)="scrollToSection('privacy-section-7')">{{ 'Privacy.section7.title' | translate }}</button>
      </div>
    </aside>

    <div class="privacy-main">
      <section class="privacy-section" id="privacy-section-1">
        <div class="privacy-section__index">01</div>
        <div class="privacy-section__body">
          <h2>{{ 'Privacy.section1.title' | translate }}</h2>
          <p>{{ 'Privacy.section1.content' | translate }}</p>
        </div>
      </section>

      <section class="privacy-section" id="privacy-section-2">
        <div class="privacy-section__index">02</div>
        <div class="privacy-section__body">
          <h2>{{ 'Privacy.section2.title' | translate }}</h2>
          <ul>
            <li *ngFor="let item of ('Privacy.section2.list' | translate)">
              {{ item }}
            </li>
          </ul>
        </div>
      </section>

      <section class="privacy-section" id="privacy-section-3">
        <div class="privacy-section__index">03</div>
        <div class="privacy-section__body">
          <h2>{{ 'Privacy.section3.title' | translate }}</h2>
          <p>{{ 'Privacy.section3.content' | translate }}</p>
        </div>
      </section>

      <section class="privacy-section" id="privacy-section-4">
        <div class="privacy-section__index">04</div>
        <div class="privacy-section__body">
          <h2>{{ 'Privacy.section4.title' | translate }}</h2>
          <p>{{ 'Privacy.section4.content' | translate }}</p>
        </div>
      </section>

      <section class="privacy-section" id="privacy-section-5">
        <div class="privacy-section__index">05</div>
        <div class="privacy-section__body">
          <h2>{{ 'Privacy.section5.title' | translate }}</h2>
          <p>{{ 'Privacy.section5.content' | translate }}</p>
        </div>
      </section>

      <section class="privacy-section" id="privacy-section-6">
        <div class="privacy-section__index">06</div>
        <div class="privacy-section__body">
          <h2>{{ 'Privacy.section6.title' | translate }}</h2>
          <p>{{ 'Privacy.section6.content' | translate }}</p>
        </div>
      </section>

      <section class="privacy-section privacy-section--contact" id="privacy-section-7">
        <div class="privacy-section__index">07</div>
        <div class="privacy-section__body">
          <h2>{{ 'Privacy.section7.title' | translate }}</h2>
          <div class="contact-card">
            <p>{{ 'Privacy.section7.company' | translate }}</p>
            <p>{{ 'Privacy.section7.address' | translate }}</p>
            <p>{{ 'Privacy.section7.email' | translate }}</p>
            <p>{{ 'Privacy.section7.phone' | translate }}</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
